'use client';

import * as Content from '@/components/content';
import gene from '@images/gene.svg';
import {
  MAX_QUERY_LENGTH,
  useGeneSearchManager,
  useMinimumLoading,
} from '../_hooks';
import { GeneCoverageHero } from '../_sections';

import AlertBar from './alert-bar';
import IconCardButton from './icon-card-button';
import SearchInputField from './search-input-field';
import SearchResult from './search-result';
import TableResultSkeleton from './table-result-skeleton';

const QUERY_TOO_LONG_ALERT = {
  title: 'Search text too long',
  message: `You can search up to ${MAX_QUERY_LENGTH.toLocaleString()} characters at once. Please shorten your search text and try again.`,
};

function GeneCoverageBrowserContent() {
  const {
    searchFilteredGeneData,
    hasSearched,
    searchedInvalidGenes,
    isDataLoading,
    prefixMatchedGenes,
    searchedPrefixes,
    isQueryTooLong,
    closeQueryTooLongAlert,
    urlSearchTerm,
    searchMode,
    triggerSearch,
  } = useGeneSearchManager();

  // 초기 데이터(CSV) 로딩 동안만 스켈레톤을 표시한다. 검색은 즉시 반영된다.
  const showSkeleton = useMinimumLoading(isDataLoading, 500);

  return (
    <>
      <GeneCoverageHero>
        <SearchInputField
          onSearch={triggerSearch}
          initialSearchTerm={urlSearchTerm}
          initialSearchMode={searchMode}
        />

        <AlertBar
          title={QUERY_TOO_LONG_ALERT.title}
          message={QUERY_TOO_LONG_ALERT.message}
          isVisible={isQueryTooLong}
          onClose={closeQueryTooLongAlert}
          className="mt-3"
        />

        {!hasSearched && (
          <div className="mt-[100px] flex w-full flex-col items-center 2xl:mb-[90px] 2xl:mt-[60px]">
            <span className="mb-5 text-center text-lg font-semibold leading-[28px] tracking-[-0.256px]">
              Learn more?
            </span>
            <IconCardButton
              iconClassName="bg-3b-blue-light-400"
              title="Gene list"
              icon={gene}
              className="flex justify-center"
            />
          </div>
        )}
      </GeneCoverageHero>

      {hasSearched && (
        <Content.Wrapper className="gap-y-[10px] py-[20px] md:gap-y-[10px] md:py-[60px]">
          {showSkeleton ? (
            <TableResultSkeleton />
          ) : (
            <SearchResult
              searchFilteredGeneData={searchFilteredGeneData}
              searchedInvalidGenes={searchedInvalidGenes}
              prefixMatchedGenes={prefixMatchedGenes}
              searchedPrefixes={searchedPrefixes}
            />
          )}
        </Content.Wrapper>
      )}
    </>
  );
}

export default GeneCoverageBrowserContent;
